import React from 'react';
import './MediaSection.css';
import { Button } from './Button';
import Cards2 from './Cards2';

function MediaSection() {
  return (
    <div className='media'>
        <h1 className='title'>Why Roblock World?</h1>
        <div className="media__container">
            <Cards2 />
        </div>
    </div>
  )
}

export default MediaSection
